exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".common-alert {\n    position: fixed;\n    z-index: 100;\n    padding-right: 20px;\n    margin-bottom: 0;\n}\n\n.common-alert p {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n    font-size: 0.95rem;\n    margin-bottom: 0;\n}\n\n.common-alert .common-alert-heading {\n    margin-top: 0.5rem;\n}\n\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/common/alert/alert.css
// module id = 4817
// module chunks = 0